import { TailSpin } from "react-loader-spinner";

export default function Loader({ loading, width = 80, height = 80 }) {
  if (loading) {
    return (
      <TailSpin
        visible={true}
        height={height}
        width={width}
        color="rgb(39, 57, 112)"
        ariaLabel="tail-spin-loading"
        radius="1"
      />
    );
  }

  return null;
}
